//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref, watch } from '@vue/composition-api'

export default {
  setup() {
    const isDialogVisible = ref(false)
    watch(isDialogVisible, value => {
      if (!value) return

      setTimeout(() => {
        isDialogVisible.value = false
      }, 4000)
    })

    return { isDialogVisible }
  },
}
